import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Integritetspolicy - Provalt Service AB</title>
        <meta
          name="description"
          content="Läs hur Provalt Service AB hanterar dina personuppgifter enligt GDPR. Vi skyddar din integritet och säkerställer trygg databehandling."
        />
          <link rel="canonical" href="https://provalt.se/integritetspolicy" />

      </Helmet>

      <section className="w-full py-16 px-4 sm:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-gray-800">
          <h1 className="text-4xl font-bold mb-8 text-center">Integritetspolicy</h1>

          <p className="text-lg mb-6">
            Provalt Service AB (org.nr 559414-1565) respekterar och skyddar din personliga integritet. Denna
            integritetspolicy förklarar hur vi samlar in, behandlar och skyddar dina personuppgifter i enlighet med
            Dataskyddsförordningen (GDPR).
          </p>

          <h2 className="text-2xl font-semibold mb-2">1. Personuppgiftsansvarig</h2>
          <p className="mb-4">
            Ansvarig för personuppgiftsbehandling är Provalt Service AB. Om du har frågor om vår hantering av personuppgifter, kontakta oss:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li><strong>Adress:</strong> Västberga Allé 32, 126 30 Hägersten</li>
            <li><strong>E-post:</strong> info@provalt.se</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-2">2. Vilka uppgifter vi samlar in</h2>
          <p className="mb-4">Vi kan samla in följande typer av personuppgifter:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Namn, e-postadress, telefonnummer och adress</li>
            <li>Betalningsinformation, fakturauppgifter</li>
            <li>Information du lämnar vid kontakt med oss (t.ex. via e-post eller formulär)</li>
            <li>Uppgifter kopplade till våra tjänster, inklusive dokumentation</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-2">3. Syftet med behandlingen</h2>
          <p className="mb-4">Vi behandlar personuppgifter för att kunna:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Leverera tjänster enligt avtal</li>
            <li>Hantera fakturering och betalning</li>
            <li>Ge kundservice och svara på förfrågningar</li>
            <li>Skicka erbjudanden och information (endast med ditt samtycke)</li>
            <li>Uppfylla lagkrav, exempelvis bokföringslagen</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-2">4. Rättslig grund för behandling</h2>
          <p className="mb-4">Vi behandlar dina uppgifter utifrån följande rättsliga grunder:</p>
          <ul className="list-disc pl-6 mb-6">
            <li><strong>Avtal:</strong> För att fullgöra våra skyldigheter mot dig</li>
            <li><strong>Samtycke:</strong> För exempelvis nyhetsbrev</li>
            <li><strong>Rättslig skyldighet:</strong> För att följa lagar och regler</li>
            <li><strong>Berättigat intresse:</strong> För att utveckla vår verksamhet (balanserat mot dina rättigheter)</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-2">5. Lagring av uppgifter</h2>
          <p className="mb-6">
            Vi sparar dina personuppgifter så länge det krävs för att uppfylla syftet med insamlingen, eller så länge vi enligt lag är skyldiga att göra det.
          </p>

          <h2 className="text-2xl font-semibold mb-2">6. Tredje parter och överföring</h2>
          <p className="mb-6">
            Vi delar inte dina uppgifter med tredje parter utan din tillåtelse, förutom om det krävs för att utföra våra tjänster (exempelvis bokföringsbyrå eller IT-leverantör). Alla parter vi samarbetar med följer GDPR.
          </p>

          <h2 className="text-2xl font-semibold mb-2">7. Dina rättigheter</h2>
          <p className="mb-4">Du har enligt GDPR rätt att:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Få tillgång till dina uppgifter</li>
            <li>Begära rättelse eller radering</li>
            <li>Invända mot behandling</li>
            <li>Begära begränsning av behandling</li>
            <li>Få dina uppgifter i ett maskinläsbart format (dataportabilitet)</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-2">8. Cookies</h2>
          <p className="mb-6">
            Vår webbplats kan använda cookies för att förbättra användarupplevelsen. Du kan hantera dina cookie-inställningar via din webbläsare.
          </p>

          <h2 className="text-2xl font-semibold mb-2">9. Ändringar i policyn</h2>
          <p className="mb-6">
            Vi kan uppdatera denna policy. Datum för senaste uppdatering visas nedan. Kontrollera gärna regelbundet.
          </p>

          <p className="text-sm text-gray-500 mt-12 text-center">Senast uppdaterad: 19 maj 2025</p>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
